var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_230_1",
    "data-name": "Component 230 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_439",
    "data-name": "Ellipse 439",
    cx: 41.5,
    cy: 41.5,
    r: 41.5,
    fill: "#0fb958"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tick",
    transform: "translate(17.028 23.059)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 15.083,
    cy: 21.98,
    rx: 15.083,
    ry: 21.98,
    transform: "translate(10.022 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M43.918,0,18.675,23.858,6.289,12.151,0,18.095,18.675,35.746l31.532-29.8Z",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccess);
export default __webpack_public_path__ + "static/media/icon-success.fe9f6bc90bf5d2c7ea9353a039c6a90b.svg";
export { ForwardRef as ReactComponent };